import * as React from "react";
const SvgFiRrScrewdriver = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-screwdriver_svg__a)">
      <path
        fill="#062147"
        d="M23.302 1.724 22.276.697A2.39 2.39 0 0 0 19.403.32l-2.98 1.72a2.85 2.85 0 0 0-1.422 2.462v3.086l-4.832 4.833a3.52 3.52 0 0 0-4.14.605l-4.913 4.9C-.201 19.236-.352 21.34.774 22.711 1.404 23.48 2.554 24 3.492 24c.927 0 1.822-.367 2.48-1.023l5.014-5a3.47 3.47 0 0 0 1.028-2.476 3.5 3.5 0 0 0-.426-1.674L16.414 9H19.5a2.85 2.85 0 0 0 2.462-1.423l1.719-2.98a2.384 2.384 0 0 0-.379-2.873M9.574 16.561l-5.015 5c-.3.3-.718.45-1.142.438a1.5 1.5 0 0 1-1.098-.557c-.479-.584-.388-1.508.208-2.102l4.913-4.9a1.512 1.512 0 0 1 2.133 0c.284.284.44.66.44 1.06 0 .402-.157.776-.44 1.06zM21.948 3.598l-1.719 2.98A.84.84 0 0 1 19.5 7H17V4.5c0-.3.161-.579.422-.729l2.98-1.72a.38.38 0 0 1 .46.061l1.025 1.026a.384.384 0 0 1 .061.46"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-screwdriver_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrScrewdriver;
